<template>
  <div class="case-header" data-cy="case-header">
    <div class="case-header-section" data-cy="case-number">
      <h4>{{ $t('viewCase.case_number') }}</h4>
      <span>{{ caseOrder.caseNumber }}</span>
    </div>
    <div v-if="caseOrder?.status" class="case-header-section" data-cy="case-status">
      <h4>{{ $t('viewCase.case_status_label') }}</h4>
      <span>{{ $t(`viewCase.case_status.${caseOrder.status.toLowerCase()}`) }}</span>
    </div>
    <div class="case-header-section" data-cy="case-creation-date">
      <h4>
        {{ caseNotSubmitted ? $t('viewCase.case_creation_date') : $t('viewCase.case_submitted_date') }}
      </h4>
      <span>{{ formatDate(caseOrder.createdAt) }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useFormat } from '@/composables/format';
import type { Case } from '@/types/case.interface';

defineProps<{
  caseOrder: Case;
  caseNotSubmitted: boolean;
}>();

const { formatDate } = useFormat();
</script>
<style scoped lang="scss">
.case-header {
  display: flex;
  align-items: center;
  background-color: var(--primary-bg-color);
  border-radius: 0.25rem 0.25rem 0 0;
  gap: 16px;

  .case-header-section {
    width: 100%;
    text-align: left;

    h4 {
      line-height: 150%;
      margin: 0 0 0.25rem;
      font-weight: 700;
      font-size: 1rem;
    }

    span {
      line-height: 150%;
      color: var(--primary-text-remark-color);
      font-weight: 400;
      font-size: 0.875rem;
    }
  }
}
</style>
